import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

const Popup = (props) => {
    return (
      <Dialog open={props.open} onClose={props.fnAnnulla}>
        <DialogTitle>{props.titolo}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {props.testo}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.fnAnnulla}>Annulla</Button>
          <Button onClick={props.fnSuccess} variant="contained">
            Continua
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default Popup;